
import yup from "src/utils/yup/extensionMethods";

const importSchema = (translate: Function) => yup.object().shape({
	delimiter: yup.string()
		.required(translate("Delimitador é requerido"))
});

export default importSchema;
